import React from 'react';

import { IconProps } from '../Icon.types';

export function Add({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Add</title>
      <path
        d="M7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75L7 11.25ZM17 12.75C17.4142 12.75 17.75 12.4142 17.75 12C17.75 11.5858 17.4142 11.25 17 11.25V12.75ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM7 12.75L12 12.75V11.25L7 11.25L7 12.75ZM12 12.75L17 12.75V11.25L12 11.25V12.75ZM11.25 7V12H12.75V7H11.25ZM11.25 12L11.25 17H12.75L12.75 12H11.25Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
